module.exports = __webpack_public_path__ + "img/Illu_Home.6055f9a6.jpg";